import type { ReactNode } from 'react';
import styles from './Badge.module.css';

type BadgeVariant = 'green' | 'cyan' | 'new' | 'hot' | 'plat' | 'spotlight';

interface BadgeProps {
  variant?: BadgeVariant;
  withPulse?: boolean;
  children: ReactNode;
  className?: string;
}

export default function Badge({
  variant = 'green',
  withPulse = false,
  children,
  className = '',
}: BadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[variant]} ${className}`}>
      {withPulse && <span className={styles.pulseDot} aria-hidden="true" />}
      {children}
    </span>
  );
}
